import createApi from "../utils/axiosInstance";

export const getAllUsers = async (
  currentTab,
  date,
  page,
  limit,
  search,
  trainingLevelId,
  createdAt,
  referenceId,
  sortBy,
  order,
  masterclassId
) => {
  try {
    const api = createApi(true);
    const response = await api.get(
      `/admin/user/get-all-users?date=${date}&page=${page}&limit=${limit}&search=${search}${
        currentTab ? `&type=${currentTab}` : ""
      }${trainingLevelId ? `&trainingLevelId=${trainingLevelId}` : ""}${
        referenceId ? `&referenceId=${referenceId}` : ""
      }${sortBy ? `&sortBy=${sortBy}&order=${order}` : ""}${
        masterclassId ? `&masterclassId=${masterclassId}` : ""
      }${
        createdAt
          ? `&startDate=${createdAt?.[0]}&endDate=${createdAt?.[1]}`
          : ""
      }`
    );
    return response.data;
  } catch (error) {
    console.error(
      "Getting user failed:",
      error.response ? error.response.data : error.message
    );
    throw error.response ? error.response.data : error;
  }
};
export const getUserStreaks = async (userId) => {
  try {
    const api = createApi(true);
    const response = await api.get(`/admin/user/get-user-streaks/${userId}`);
    return response.data;
  } catch (error) {
    console.error(
      "Get user diary level failed:",
      error.response ? error.response.data : error.message
    );
    throw error.response ? error.response.data : error;
  }
};
export const resetAllTraining = async (data) => {
  try {
    const api = createApi(true);
    const response = await api.post(
      `/admin/user/reset-training-progress`,
      data
    );
    return response.data;
  } catch (error) {
    console.error(
      "Reset training progress failed:",
      error.response ? error.response.data : error.message
    );
    throw error.response ? error.response.data : error;
  }
};
export const getAllCoupons = async (tab) => {
  try {
    const api = createApi(true);
    const response = await api.get(`/payment/coupon/get-coupons?tab=${tab}`);
    return response.data;
  } catch (error) {
    console.error(
      "Getting coupons failed:",
      error.response ? error.response.data : error.message
    );
    throw error.response ? error.response.data : error;
  }
};

export const getCouponUser = async (couponId) => {
  try {
    const api = createApi(true);
    const response = await api.get(
      `/payment/coupon/get-coupon-users/${couponId}`
    );
    return response.data;
  } catch (error) {
    console.error(
      "Getting coupon users failed:",
      error.response ? error.response.data : error.message
    );
    throw error.response ? error.response.data : error;
  }
};

export const getAdditionalBundleCouponPurchase = async (type, date = "") => {
  try {
    const api = createApi(true);
    const response = await api.get(
      `/payment/coupon/additional-bundle-purchase/${type}${
        date ? `?date=${date}` : ""
      }`
    );
    return response.data;
  } catch (error) {
    console.error(
      "Purchasing using coupon users failed:",
      error.response ? error.response.data : error.message
    );
    throw error.response ? error.response.data : error;
  }
};
export const getAllChallenges = async (id = "") => {
  try {
    const api = createApi(true);
    const response = await api.get(
      `/admin/challenges/get-challenge${id ? `?referenceId=${id}` : ""}`
    );
    return response.data;
  } catch (error) {
    console.error(
      "Getting challenges failed:",
      error.response ? error.response.data : error.message
    );
    throw error.response ? error.response.data : error;
  }
};
export const getSingleChallengeWithDateRange = async ({
  challengeId,
  startDate,
  endDate,
  referenceId
}) => {
  try {
    const api = createApi(true);
    const response = await api.get(
      `/admin/challenges/get-single-challenge?challengeId=${challengeId}&startDate=${startDate}&endDate=${endDate}${
        referenceId ? `&referenceId=${referenceId}` : ""
      }`
    );
    return response.data;
  } catch (error) {
    console.error(
      "Getting challenges failed:",
      error.response ? error.response.data : error.message
    );
    throw error.response ? error.response.data : error;
  }
};

export const getAllTempaltes = async () => {
  try {
    const api = createApi(true);
    const response = await api.get(`/admin/user/email/templates`);
    return response.data;
  } catch (error) {
    console.error(
      "Getting All Templates failed:",
      error.response ? error.response.data : error.message
    );
    throw error.response ? error.response.data : error;
  }
};

export const updateTemplate = async (template) => {
  try {
    const api = createApi(true);
    const response = await api.put(
      `/admin/user/email/templates/${template?._id}`,
      template
    );
    return response.data;
  } catch (error) {
    console.error(
      "Updating Templates failed:",
      error.response ? error.response.data : error.message
    );
    throw error.response ? error.response.data : error;
  }
};
export const purchaseTrainingBulk = async (items) => {
  try {
    const api = createApi(true);
    const response = await api.post("/admin/user/purchase-training-for-users", {
      items
    });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};

export const purchaseUserTraining = async (data) => {
  try {
    const api = createApi(true); // Token required
    const response = await api.post(
      `/admin/user/purchase-training-for-users`,
      data
    );
    return response.data;
  } catch (error) {
    console.error(
      "Generating url failed:",
      error.response ? error.response.data : error.message
    );
    throw error.response ? error.response.data : error;
  }
};

export const addnewChallenge = async (data) => {
  try {
    const api = createApi(true);
    const response = await api.post(`/admin/challenges/add-challenge`, data);
    return response.data;
  } catch (error) {
    console.error(
      "Adding challenge failed:",
      error.response ? error.response.data : error.message
    );
    throw error.response ? error.response.data : error;
  }
};

export const editChallengeHandler = async (data) => {
  try {
    const api = createApi(true);
    const response = await api.post(
      `/admin/challenges/edit-challenge/${data.id}`,
      data
    );
    return response.data;
  } catch (error) {
    console.error(
      "Editing challenge failed:",
      error.response ? error.response.data : error.message
    );
    throw error.response ? error.response.data : error;
  }
};

export const deleteChallengeHandler = async (data) => {
  try {
    const api = createApi(true);
    const response = await api.delete(
      `/admin/challenges/delete-challenge/${data.id}`
    );
    return response.data;
  } catch (error) {
    console.error(
      "Deleting challenge failed:",
      error.response ? error.response.data : error.message
    );
    throw error.response ? error.response.data : error;
  }
};

export const deleteCouponHandler = async (data) => {
  try {
    const api = createApi(true);
    const response = await api.delete(
      `/payment/coupon/remove-coupon/${data.id}/${data.tab}`
    );
    return response.data;
  } catch (error) {
    console.error(
      "Deleting coupons failed:",
      error.response ? error.response.data : error.message
    );
    throw error.response ? error.response.data : error;
  }
};
export const addnewCoupon = async (data) => {
  try {
    const api = createApi(true);
    const response = await api.post(`/payment/coupon/add-coupon`, data);
    return response.data;
  } catch (error) {
    console.error(
      "Adding coupons failed:",
      error.response ? error.response.data : error.message
    );
    throw error.response ? error.response.data : error;
  }
};
export const editCouponHandler = async (data) => {
  try {
    const api = createApi(true);
    const response = await api.put(
      `/payment/coupon/edit-coupon/${data.id}`,
      data
    );
    return response.data;
  } catch (error) {
    console.error(
      "Editing coupons failed:",
      error.response ? error.response.data : error.message
    );
    throw error.response ? error.response.data : error;
  }
};
export const generatePreSignedUrl = async (data) => {
  try {
    const api = createApi(true);
    const response = await api.post(`/user/generate-signed-url`, data);
    return response.data;
  } catch (error) {
    console.error(
      "Generating signed url data:",
      error.response ? error.response.data : error.message
    );
    throw error.response ? error.response.data : error.message;
  }
};

export const deleteS3File = async (data) => {
  try {
    const api = createApi(true);
    const response = await api.post(`/user/delete-s3-file`, data);
    return response.data;
  } catch (error) {
    console.error(
      "Deleting data:",
      error.response ? error.response.data : error.message
    );
    throw error.response ? error.response.data : error.message;
  }
};
export const getUsersByType = async (
  page,
  date,
  limit,
  search,
  sortBy,
  order
) => {
  try {
    const api = createApi(true);
    const response = await api.get(
      `/admin/user/get-admin-user-list?date=${date}&page=${page}&limit=${limit}&search=${search}${
        sortBy ? `&sortBy=${sortBy}&order=${order}` : ""
      }`
    );
    return response.data;
  } catch (error) {
    console.error(
      "Getting user failed:",
      error.response ? error.response.data : error.message
    );
    throw error.response ? error.response.data : error;
  }
};

export const updateCode = async (code, id, adminCodes) => {
  try {
    const api = createApi(true);
    const response = await api.put(
      `/admin/user/update-code${id ? `/${id}` : ""}`,
      id ? { code } : adminCodes
    );
    return response.data;
  } catch (error) {
    console.error(
      "Completing profile failed:",
      error.response ? error.response.data : error.message
    );
    throw error.response ? error.response.data : error.message;
  }
};

export const deleteUserHandler = async (userId, hardDeleteNeeded) => {
  try {
    const api = createApi(true);
    const response = await api.delete(
      `/admin/user/delete-user/${userId}?hardDeleteNeeded=${hardDeleteNeeded}`
    );
    return response.data;
  } catch (error) {
    console.error(
      "Getting user failed:",
      error.response ? error.response.data : error.message
    );
    throw error.response ? error.response.data : error;
  }
};

export const removeAccessUserHandler = async (userId) => {
  try {
    const api = createApi(true);
    const response = await api.get(`/admin/user/remove-access-user/${userId}`);
    return response.data;
  } catch (error) {
    console.error(
      "Removing user access failed:",
      error.response ? error.response.data : error.message
    );
    throw error.response ? error.response.data : error;
  }
};

export const updateUserToCoach = async (email) => {
  try {
    const api = createApi(true);

    const response = await api.post(`/user/convert-user-to-coach`, { email });
    return response.data;
  } catch (error) {
    console.error(
      "Updating user failed:",
      error.response ? error.response.data : error.message
    );
    throw error.response ? error.response.data : error;
  }
};

// Weight Tracker API Functions
export const fetchWeightData = async (params) => {
  try {
    const api = createApi(true); // Token required
    const response = await api.get(`/weight/`, { params });
    return response.data;
  } catch (error) {
    console.error(
      "fetching weight field failed:",
      error.response ? error.response.data : error.message
    );
    throw error.response ? error.response.data : error;
  }
};
export const fetchAvgData = async (params) => {
  try {
    const api = createApi(true); // Token required
    const response = await api.get(`/weight/latest-avg`, { params });
    return response.data;
  } catch (error) {
    console.error(
      "fetching average data failed:",
      error.response ? error.response.data : error.message
    );
    throw error.response ? error.response.data : error;
  }
};

export const postWeightData = async ({ userId, timestamp, weight, unit }) => {
  try {
    const api = createApi(true);
    const response = await api.post(`/weight/add-weight`, {
      userId,
      timestamp,
      weight,
      unit
    });
    return response.data;
  } catch (error) {
    console.error(
      "Posting weight data failed:",
      error.response ? error.response.data : error.message
    );
    throw error.response ? error.response.data : error;
  }
};

export const deleteWeightEntry = async ({ userId, date }) => {
  try {
    const api = createApi(true);
    const response = await api.delete(
      `/weight/delete-weight?userId=${userId}&date=${date}`
    );
    return response.data;
  } catch (error) {
    console.error(
      "Deleting weight entry failed:",
      error.response ? error.response.data : error.message
    );
    throw error.response ? error.response.data : error;
  }
};
